define(function (require, exports) {
    'use strict';

    exports.metroMeta = {
        CONSTANTS_TRANSACTIONS: {
            TRANSACTIONS: [
                {label: 'Entered By', key: 'entered_by', sortable: false, colspan: null, show: 'showEnteredByColumn'},
                {label: 'Payer Name', key: 'payer_name', sortable: false, colspan: null, show: 'showPayerNameColumn'},
                {label: 'Payer Account No', key: 'payer_account_no', sortable: false, colspan: null, show: 'showPayerAccountColumn'},
                {label: 'Payee Name', key: 'payee_name', sortable: false, colspan: null, show: 'showPayeeNameColumn'},
                {label: 'Payee Account No', key: 'payee_account_no', sortable: false, colspan: null, show: 'showPayeeAccountColumn'},
                {label: 'Payee Sort Code / BIC Code', key: 'payer_account_no', sortable: false, colspan: null, show: 'showSortCodeColumn'},
                {label: 'Transaction Type', key: 'transaction_type', sortable: false, colspan: null, show: 'showTransactionTypeColumn'},
                {label: 'Payment Date', key: 'payment_date', sortable: true, colspan: null, show: 'showPaymentDateColumn'},
                {label: 'Debit Amount', key: 'debit_amount', sortable: false, colspan: 2, show: 'showDebitAmountColumn'},
                {label: 'Credit Amount', key: 'credit_amount', sortable: false, colspan: 2, show: 'showCreditAmountColumn'},
                {label: 'Status', key: 'status', sortable: false, colspan: null, show: 'showStatusColumn'},
                {label: 'Reason', key: 'reason', sortable: false, colspan: null, show: 'showReasonColumn'},
                {label: 'From Account', key: 'from_account', sortable: false, colspan: null, show: 'showFromAccount'},
                {label: 'Frequency', key: 'frequency', sortable: false, colspan: null, show: 'showFrequency'},
                {label: 'To Account', key: 'to_account', sortable: false, colspan: null, show: 'showToAcount'},
                {label: 'Next Transfer Date', key: 'reason', sortable: false, colspan: null, show: 'showNextTransferDate'},
                {label: 'Amount', key: 'Amount', sortable: false, colspan: 2, show: 'showAmount'},
                {label: '', key: 'delete', sortable: false, colspan: null, show: 'showDeleteColumn'}
            ],
            PREFERENCES: [
                'showEnteredByColumn',
                'showPayerNameColumn',
                'showPayerAccountColumn',
                'showPayeeNameColumn',
                'showPayeeAccountColumn',
                'showSortCodeColumn',
                'showTransactionTypeColumn',
                'showPaymentDateColumn',
                'showDebitAmountColumn',
                'showCreditAmountColumn',
                'showStatusColumn',
                'showReasonColumn',
                'showFromAccount',
                'showFrequency',
                'showToAcount',
                'showNextTransferDate',
                'showAmount',
                'maxNameCharsToDisplay',
                'maxReasonCharsToDisplay'
            ]
        },
        MODAL: {
            errorHandling: {
                show: false,
                success: {
                    title: 'Success',
                    showIcon: true,
                    iconClasses: 'fa fa-check-circle fa-lg',
                    iconColor: 'green',
                    message: 'Your changes are being processed',
                    messageType: 'success'
                },
                error: {
                    title: 'Error',
                    showIcon: true,
                    iconClasses: 'fa fa-warning fa-lg',
                    iconColor: 'red',
                    message: 'Something went wrong',
                    messageType: 'danger'
                }
            },
            hardToken: {
                show: false,
                message: {
                    title: 'Process',
                    showIcon: false,
                    message: 'Are you sure you want to continue with this update?',
                    messageType: 'warning'
                },
                success: {
                    title: 'Success',
                    showIcon: true,
                    iconClasses: 'fa fa-check-circle fa-lg',
                    iconColor: 'green',
                    message: 'Your changes are being processed',
                    messageType: 'success'
                },
                error: {
                    title: 'Error',
                    showIcon: true,
                    iconClasses: 'fa fa-warning fa-lg',
                    iconColor: 'red',
                    message: 'You have exceeded your number of hard token attempts. Please contact customer service on NNN-NNN-NNNN',
                    messageType: 'danger'
                }
            }
        },
        SEARCH_TYPES: [
            {
                name: 'Account Name',
                value: 'accountName'
            },
            {
                name: 'Account Number',
                value: 'accountId'
            },
            {
                name: 'Beneficiary Nickname',
                value: 'beneficiaryName'
            }
        ],

        SEARCH_TYPES2: [
            {
                name: 'Account Name',
                value: 'title'
            },
            {
                name: 'Account Number',
                value: 'businessKey'
            },
            {
                name: 'Account Nickname',
                value: 'nickname'
            }
        ],
        SEARCH_TYPES3: [
            {
                name: 'Beneficiary Name',
                value: 'title'
            },
            {
                name: 'Beneficiary Nickname',
                value: 'nickname'
            },
            {
                name: 'Account Number',
                value: 'accountId'
            }

        ],
        PROPERTYTRANSCATIONS_CODE_FOR_CHAPS : [
            {id : 1, value : "HLRP" , description : "Property Loan Repayment", key : "hlrp"},
            {id : 2, value : "HLST" , description : "Property Loan Settlement" ,  key : "hlst" },
            {id : 3, value : "PLDS" , description : "Property Loan Disbursement" , key : "plds"},
            {id : 4, value : "PDEP" , description : "Property Deposit" , key : "pdep"},
            {id : 5, value : "PCOM" , description : "Property Completion Payment" , key : "pcom"},
            {id : 6, value : "PLRF" , description : "Property Loan Refinancing" , key : "plrf"},
        ],
        NOTIFICATIONS: {
            VALID_HARD_TOKEN: {
                notification: {
                    id: '999',
                    icon: 'lock',
                    level: 'warning',
                    closable: true,
                    message: 'Enter a valid hard token. (this message is temporary until we have a generic hard token validation)'
                }
            },
            NO_CANCELLED_DIRECT_DEBITS: {
                level: 'warning',
                icon: 'warning',
                message: 'There are no cancelled direct debits'
            },
            NO_ACTIVE_DIRECT_DEBITS: {
                level: 'warning',
                icon: 'warning',
                message: 'There are no active direct debits'
            }
        },
        PAYMENT_TYPES: [
            {
                name: 'Faster Payments',
                value: 'FASTER_PAYMENTS',
                tooltipKey: 'payment-type-faster-payments-description',
                enabled: false,
                allowScheduling: false
            },
            {
                name: 'BACS',
                value: 'BACS',
                tooltipKey: 'payment-type-bacs-description',
                enabled: false,
                allowScheduling: true
            },
            {
                name: 'CHAPS',
                value: 'CHAPS',
                tooltipKey: 'payment-type-chaps-description',
                enabled: false,
                allowScheduling: true
            },
            {
                name: 'INTL',
                value: 'INTL',
                tooltipKey: 'payment-type-international-description',
                enabled: false,
                allowScheduling: true
            }
        ],
        DOMESTIC_PAYMENT_TYPES: [
            {
                name: 'Transfers',
                value: 'TRANSFERS',
                enabled: false,
                allowScheduling: true,
                tooltipKey: 'payment-type-transfer-description'
            },
            {
                name: 'Metro Bank Payments',
                value: 'MB_PAYMENTS',
                enabled: false,
                allowScheduling: false,
                tooltipKey: 'payment-type-mb-payments-description'
            },
            {
                name: 'Faster Payments',
                value: 'FASTER_PAYMENTS',
                enabled: false,
                allowScheduling: false,
                tooltipKey: 'payment-type-faster-payments-description'
            },
            {
                name: 'BACS',
                value: 'BACS',
                enabled: false,
                allowScheduling: false,
                tooltipKey: 'payment-type-bacs-description'
            },
            {
                name: 'CHAPS',
                value: 'CHAPS',
                enabled: false,
                allowScheduling: false,
                tooltipKey: 'payment-type-chaps-description'
            }
        ],
        BATCH_PAYMENTS: [
            {
                name: 'Faster Payments',
                value: 'FASTER_PAYMENTS',
                enabled: false,
                allowScheduling: false,
                tooltipKey: 'PAYMENT_TYPE_FASTER_PAYMENTS_DESCRIPTION',
                reason: 'not enabled'
            }, {
                name: 'BACS',
                value: 'BACS',
                enabled: false,
                allowScheduling: true,
                tooltipKey: 'PAYMENT_TYPE_BACS_DESCRIPTION',
                reason: 'not enabled'
            }, {
                name: 'CHAPS',
                value: 'CHAPS',
                enabled: false,
                allowScheduling: false,
                tooltipKey: 'PAYMENT_TYPE_CHAPS_DESCRIPTION',
                reason: 'not enabled'
            }
        ],
        MESSAGES: {
            errorMessages: {
                sortCode: 'Invalid sort code',
                sortCodeTooShort: 'Invalid Sort Code. Are you missing a leading zero or a number?',
                accountNumber: 'Invalid Account Number'
            },

            paymentReferenceMessages: {
                maxlength: 'The reference entered is too long'
            },

            sortCodeErrorMessages: {
                required: 'Please enter a sort code',
                sortCode: 'Invalid sort code',
                sortCodeTooShort: 'Invalid Sort Code. Are you missing a leading zero or a number?'
            },

            accountNumberMessages: {
                required: 'Please enter an account number',
                accountNumber: 'Invalid Account Number',
                accountNumberLength: 'Account number must be 8 digits. Please check the account details and try again. If payee account number is shorter, please add zero(s) at the start of the number.',
                accountNumberLengthExisting: 'To process payments successfully, account numbers now need to have 8 digits. This payee only has 7. Please delete it and re-enter their details, putting a zero at the very front of their account number. i.e. Account number 1234567 becomes 01234567'
            },

            beneficiaryNameErrorMessages: {
                required: 'Please enter a payee name or select one from the address book'
            },
            noActivePaymentTypes : {
                message: 'This payment type could be unavailable due to:',
                noPermission: 'Insufficient access or mandate permissions',
                noPaymentType: 'The beneficiary cannot receive the payment type',
                paymentTypeUnavailable: 'The payment type being unavailable from your selected debit account'
            }
        },
        STATUS: {
            status: {
                isFirstOpen: true,
                isFirstDisabled: false
            }
        },
        ENVIRONMENT:{
            APPTYPE:{
                isWeb:'Web'
            },
            DEV:{
                isDev: 'Dev'
            },
            STAGING:{
                isStaging: 'Staging',
                url:'commercial-pp.metrobankonline.co.uk'
            },
            PROD:{
                isProd: 'Prod',
                url:'commercial.metrobankonline.co.uk'
            }
        },
        EVENT:{
            buttonAction:'buttonAction',
            toggleAction:'toggleAction',
            pageLoaded:'pageLoaded',
            error:'error',
            radioAction:'radioAction',
            hoverAction:'hoverAction',
            goal:'goals',
            textentry:'textEntry',
            notification : 'notification'
        },
        PAGEURL:{
            pageURL:'https://commercial.metrobankonline.co.uk'
        },
        EVENTNAME:{
            toggleSelect:'toggleSelect',
            buttonClick:'buttonClick',
            errorNotification:'errorNotification',
            radioSelect:'radioSelect',
            permissionNotification: 'permissionNotification',
            goal: 'goals',
            textentry: 'textEntry',
            notification : 'notification'
        },
        EVENTACTION: {
            createSweepReview: 'create sweep - review',
            createSweepSuccess: 'create sweep - success',
            createSweepError: 'create sweep - error',
            deleteSweepReview: 'delete sweep - review',
            deleteSweepSuccess: 'delete sweep - success',
            sca: 'sca',
            popup: 'pop up',
            inline:'inline'
        },
        LOGINPAGE:{
            login:'login',
            loginUrl:'/business-login',
            hardTokePage:'Login - Hard Token Page | Metrobank',
            seedsPage: 'Login - Seeds | Metrobank',
            bindPopupPage:'Login - Bind/UnBind Pop-up | Metrobank',
            validateHardToken:'login - validate hardtoken',
            transmitValidate: 'login - validate via transmit',
            loginValidate: 'login - validate',
            bindPopup: 'login - bind/unbind popup',
            validatePasswordSeed: 'login - validate password and seeds'
       },
       TRANSMIT:{
           PAYMENT:{
            FLOW:'payment',
            BENEFICIARY:'beneficiary',
            SINGLE_PAYMENT_NEW_PAYEE:'single_payment_new_payee',
            SINGLE_PAYMENT_EXISTING_PAYEE:'single_payment_existing_payee',
            BATCH_PAYMENT:'batch_payment',
            BULK_PAYMENT:'bulk_payment',
            OUTSTANDING_PAYMENTS_MANAGEMENT:'outstanding_payments_management',
            RECURRING_TRANSFERS:'recurring_transfers',
            STANDING_ORDER:'standing_order',
            BULK_BENEFICIARY:'bulk_ben',
            INTERNATIONAL:'int',
            DOMESTIC:'dom',
            BILLER:'bil',
            TRUSTED_BENEFICIARY:'trusted_ben',
            CREATE:'create',
            EDIT:'edit',
            AMEND:'amend',
            APPROVAL: 'approval'
           },
           HRP:{
            FLOW:'HRP',
            USER:'user',
            ACCESS_GROUPS:'access_groups',
            ACCOUNT_GROUPS:'account_groups',
            CHANGE:'change',
            CREATE:'create'
           },
           CARDS:{
            JOURNEYWITHTRANACTIONLIST:'authorise online payments',
            JOURNEYSTARTEVENTDETAIL:'s1 - started',
            JOURNEYCOMPLETEDDETAIL:'s1 - completed',
            JOURNEYCOMPLETEDWITHRESULTDETAIL:'s3 - completed',
            CONFIRMACTIONWITHAPPROVAL:'authorise online payments: approval',
            CONFIRMACTIONWITHCARDAPPROVAL:'authorise your card: approval',
            JOURNEYCUSSESSAPPROVAL: 'authorise online payments: approval',
            CONFIRMACTIONWITHDECLINE:'authorise online payments: decline',
            JOURNEYCUSSESSWTHDECLINE:'authorise online payments: decline',
            APPROVEDPAYMENT:'approved payment',
            DECLINEDPAYMENT:'declined payments',
            APPROVEDCARD:'approved card addition',
            DECLINECARD:'declined card addition'
        },
        SCA:{
            CARDAPPROVALJOURNEYSTARTEVENTDETAIL:'s2 - started',
            CARDAPPROVALJOURNEYCOMPLETEDDETAIL:'s2 - completed',
            CARDJOURNEYSTARTEVENT: 'authorise online payments: approval',
            PASSWORDTEXTENTRY : 'authenticating online payments: password',
            DEVICEPASSCODETEXTENTRY : 'authenticating online payments: password',
        }

       }
    };
});



// WEBPACK FOOTER //
// ./scripts/services/metroMeta.js